import { typeServices } from '../../services/dispachGroups/types';
import { typeRides } from '../../services/rides/types';
import { typeSelfService } from '../../services/selfService/types';
import { PendingType } from './type';
import { findPendingOperation } from './utils';

export const name = 'pendings';

export const types = {
    START_PENDING_OPERATION: `${name}/START_PENDING_OPERATION`,
    STOP_PENDING_OPERATION: `${name}/STOP_PENDING_OPERATION`,
    CLEAR_ALL: `${name}/CLEAR_ALL`,
};

export interface PendingOperationStateState {
    actions: PendingType[];
}

const initialState: PendingOperationStateState = {
    actions: [],
};

function isActionAlreadyExist(state: PendingOperationStateState, type: string): boolean {
    return !!state.actions.find((el) => el.type === type);
}

const reducer = (state = initialState, action: any = {}): any => {
    const findAction: boolean = isActionAlreadyExist(state, action.payload?.type);
    const foundAction = state.actions.find((el) => el.type === action.payload?.type);
    switch (action.type) {
        case types.START_PENDING_OPERATION:
            if (findAction) {
                return {
                    ...state,
                    actions: state.actions.map((item) => {
                        if (action.payload.type === item.type) {
                            return {
                                ...item,
                                count: item.count + 1,
                            };
                        }
                        return item;
                    }),
                };
            }
            return {
                ...state,
                actions: [...state.actions, { type: action.payload.type, count: 1 }],
            };

        case types.STOP_PENDING_OPERATION:
            if (foundAction && foundAction.count > 1) {
                return {
                    ...state,
                    actions: state.actions.map((item) => {
                        if (action.payload.type === item.type) {
                            return {
                                ...item,
                                count: item.count - 1,
                            };
                        }
                        return item;
                    }),
                };
            }
            return {
                ...state,
                actions: state.actions.filter((el) => el.type !== action.payload.type),
            };

        case types.CLEAR_ALL:
            return initialState;
        default:
            return state;
    }
};
export default reducer;

const localState = (state: any): PendingOperationStateState => state[name] || initialState;
export const selectors = {
    actions: (state): PendingType[] => localState(state).actions,
    isAppLoading: (state): boolean => selectors.actions(state).length >= 1,

    isGettingRides: (state): boolean => findPendingOperation(selectors.actions(state), typeRides.GET_RIDES),
    isExportingRides: (state): boolean => findPendingOperation(selectors.actions(state), typeRides.GET_RIDES),
    isGettingRidesSoon: (state): boolean => findPendingOperation(selectors.actions(state), typeRides.GET_SOON_RIDES),

    isGettingQuotes: (state): boolean => findPendingOperation(selectors.actions(state), typeServices.GET_SERVICES),

    isResuming: (state): boolean => findPendingOperation(selectors.actions(state), typeSelfService.RESUME_SELFSERVICE),
};
